import { useTranslation } from 'react-i18next';
import { ExportIcon } from '@saesa/ui-kit-front';
import useStyles from './OutageDashboardStyles';
import { abrirEstoySinLuz } from './outageDashboard.helpers';

/**
 * Caja CTA para reportar un corte (Estoy sin luz).
 * @param textoInfo copy informativo encima del botón
 * @param testIdBox data-testid del contenedor
 * @param testIdBoton data-testid del botón
 */
const OutageReportarBox = ({ textoInfo, testIdBox, testIdBoton }: { textoInfo: string; testIdBox: string; testIdBoton: string }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.reportarBox} data-testid={testIdBox}>
      <p className={styles.reportarTexto}>{textoInfo}</p>
      <button type="button" className={styles.botonReportar} onClick={abrirEstoySinLuz} data-testid={testIdBoton}>
        {t('desconexion:paginas.mapaCortes.modalTracking.dashboard.avance.reportarCta')}
        <ExportIcon className={styles.iconReportar} />
      </button>
    </div>
  );
};

export default OutageReportarBox;
